module.exports = __webpack_public_path__ + "img/i_data.50b78099.svg";